import { useEffect, useContext, useRef, memo } from "react";
import GlobalContext from "shared/GlobalContext";
import Overlayer from "shared/components/Overlayer";
import Loader from "shared/components/Loader";

export default memo(function QlikObject({
  id,
  height = "250px",
  showLoader = true,
  showDataView = false,
  noInteraction = false,
  noSelections = false,
  disableInteractivity = false,
  onTapEvent = null,
  maximized = false,
}) {
  const { app, qlik } = useContext(GlobalContext);
  const el = useRef(null);
  const qViz = useRef(null);

  useEffect(() => {

    if (id === "CurrentSelections") {
      app.getObject(el.current, id).then((qmodel) => {
        qViz.current = qmodel;
      });
    } else {
      app.visualization.get(id).then((qmodel) => {
        qmodel.show(el.current, { noInteraction, noSelections });
        qViz.current = qmodel;
      });
    }

    return () => {
      if (qViz.current) {
        qViz.current.close();
        qViz.current = null;
      }
    };
  }, [app, id, noInteraction, noSelections]);

  useEffect(() => {
    if (qViz.current) qlik.resize(id);
  }, [qlik, id, height, maximized]);

  useEffect(() => {
    if (qViz.current) qViz.current.toggleDataView();
  }, [showDataView]);

  return (
    <>
      {disableInteractivity && (
        <Overlayer height={height} onTapEvent={onTapEvent} />
      )}
      <div
        ref={el}
        className={`qchart ${maximized ? "maximized" : ""}`}
        style={maximized ? {} : { height }}
      >
        {showLoader && <Loader />}
      </div>
    </>
  );
});
